export const UPDATE_EMAIL = 'UPDATE_EMAIL';

export const UPDATE_PASSWORD = 'UPDATE_PASSWORD';

export const UPDATE_EMAIL_RECEIVES = 'UPDATE_EMAIL_RECEIVES';
export const AGREE_TO_TERMS = 'USER/AGREE_TO_TERMS';
export const TOGGLE_AGREE_TO_TERMS = 'USER/TOGGLE_AGREE_TO_TERMS';

export const SHOW_USER = 'USER/SHOW_USER';



// WEBPACK FOOTER //
// ./src/store/modules/profileDetails/types.js